import { useOperationsStore } from '@operations/AppProvider'
import { ReeferMonitoringContainerV2 } from '@operations/features/reeferMonitoring/containers/ReeferMonitoringContainerV2'
import { ReeferMonitoringDetailsContainers } from '@operations/features/reeferMonitoring/containers/ReeferMonitoringDetailsContainer'
import { ReeferMonitoringDialogContainer } from '@operations/features/reeferMonitoring/containers/ReeferMonitoringDialogContainer'
import { ReeferMonitoringDrawerContainer } from '@operations/features/reeferMonitoring/containers/ReeferMonitoringDrawerContainer'
import { ReeferMonitoringDetailsUIStore } from '@operations/features/reeferMonitoring/stores/reefer-monitoring-details.ui-store'
import { useTranslate } from '@tolgee/react'
import { observer } from 'mobx-react-lite'
import { ReactNode, useEffect, useMemo } from 'react'
import { Helmet } from 'react-helmet-async'

interface Props {
  maxPluggedOutComponent?: ReactNode
}
export const ReeferMonitoring = observer(({ maxPluggedOutComponent }: Props) => {
  const { t } = useTranslate()

  const { reeferTemperatureStoreV2, reeferMonitoringUIStoreV2, tenantConfigStore } =
    useOperationsStore()

  const reeferMonitoringDetailsUIStore = useMemo(
    () => new ReeferMonitoringDetailsUIStore(reeferMonitoringUIStoreV2),
    [reeferMonitoringUIStoreV2],
  )

  useEffect(() => {
    reeferTemperatureStoreV2.loadInProgressCoolingOrders()
  }, [reeferTemperatureStoreV2])

  return (
    <>
      <Helmet>
        <title>{t('reeferMonitoringTomOperation', 'Reefer Monitoring - Tom Operation')}</title>
      </Helmet>

      {reeferMonitoringDetailsUIStore.isOpen ? (
        <ReeferMonitoringDetailsContainers
          reeferMonitoringDetailsUIStore={reeferMonitoringDetailsUIStore}
          maxPluggedOutTime={tenantConfigStore.tenantConfig?.reeferContainerMaxUnpluggedTime}
        />
      ) : (
        <ReeferMonitoringContainerV2
          maxPluggedOutComponent={maxPluggedOutComponent}
          reeferMonitoringDetailsUIStore={reeferMonitoringDetailsUIStore}
        />
      )}

      <ReeferMonitoringDrawerContainer />
      <ReeferMonitoringDialogContainer
        reeferMonitoringDetailsUIStore={reeferMonitoringDetailsUIStore}
      />
    </>
  )
})
